import swal from 'sweetalert';
import axiosInstance from '../api';
import {
  setOrderList,
  setOrderListView,
  setStatusList,
} from '../../reusableSlice';

export const getOrderList = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get('admin/orders', { params: data });
    dispatch(setOrderList(response?.data?.response ?? []));
  } catch {
    dispatch(setOrderList([]));
  }
};

export const getSingleOrderView = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/orders/${id}`);
    dispatch(setOrderListView(response?.data?.response ?? []));
  } catch {
    dispatch(setOrderListView([]));
  }
};

export const getStatusList = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get('admin/statuses');
    dispatch(setStatusList(response?.data?.response ?? []));
  } catch {
    dispatch(setStatusList([]));
  }
};

const showResult = (response) => {
  if (response?.data?.status) {
    swal({
      text: response?.data?.response?.message,
      icon: 'success',
      button: 'Close',
      timer: 1500,
    });
    return true;
  }
  swal({
    text: response?.data?.message,
    icon: 'error',
    button: 'Close',
    timer: 1500,
  });
  return false;
};

export const EditOrderDetails = (data, setLoading) => async () => {
  setLoading?.(true);
  try {
    const response = await axiosInstance.patch('admin/orders/status', data);
    return { ok: showResult(response), response };
  } catch (error) {
    return { ok: false, error };
  } finally {
    setLoading?.(false);
  }
};

export const bulkUpdateOrderStatus = (ids, status, setLoading) => async () => {
  setLoading?.(true);
  try {
    const response = await axiosInstance.patch('admin/orders/status/bulk', {
      ids,
      status,
    });
    const payload = response?.data;
    if (payload?.status) {
      return {
        ok: true,
        message: payload?.response?.message,
        updatedIds: payload?.response?.updated_ids ?? [],
        failedIds: payload?.response?.failed_ids ?? [],
      };
    }
    swal({
      text: payload?.message || 'Bulk update failed',
      icon: 'error',
      button: 'Close',
      timer: 2000,
    });
    return { ok: false };
  } catch (error) {
    swal({
      text: error?.response?.data?.message || 'Bulk update failed',
      icon: 'error',
      button: 'Close',
      timer: 2000,
    });
    return { ok: false, error };
  } finally {
    setLoading?.(false);
  }
};

